import { combineReducers } from 'redux'
import createTemporary from './createTemporary'

export default combineReducers({
  createTemporary,
})
